/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

export function trimOutlet(outlet: string): string {
  if (!outlet) {
    return '';
  }
  // Remove outlet parameters like (param1:value1)
  return outlet.replace(/\([^)]*:[^)]*\)/g, '');;
}
